import styled from 'styled-components'
import Stack from '@careguide/stack'

const LayoutDesktop = styled(Stack).attrs({
  direction: 'horizontal',
  valign: 'center',
  align: 'space-between',
  gap: '2',
  as: 'span',
})`
  @media (max-width: calc(${({ theme }) => theme.breakpoints.desktop} - 1px)) {
    display: none;
  }
`

export default LayoutDesktop
